import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

// ✅ Axios Global Configuration
// axios.defaults.baseURL = "http://127.0.0.1:8000/api";
axios.defaults.baseURL = "https://axionacademyadmin.mysoftcode.com/api";
// axios.defaults.baseURL = "https://axadmin.axionacademy.lk/api";
axios.defaults.crossDomain = true;
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Content-Type"] = "application/json";
const token = localStorage.getItem("token");

if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

console.log("Base URL:", axios.defaults.baseURL);

createApp(App).use(store).use(router).mount("#app");
